import { Cat, Flame, MoreHorizontal, User } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { getDatabaseUserLink, getDbAdminLink, getRevenueCatCustomerLink } from '../utils/linkUtils'
import CopyButton from './CopyButton'

type UserLinksProps = {
    userId: string
    mode?: 'normal' | 'compact'
}

const linkClass = "px-2 py-1 bg-white hover:bg-white/60 rounded transition-colors border border-gray-200"

export const UserLinks = ({ userId, mode = 'normal' }: UserLinksProps) => {
    const [menuOpen, setMenuOpen] = useState(false)
    const menuRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!menuOpen) return
        const handleClickOutside = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setMenuOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [menuOpen])

    const links = (
        <>
            <CopyButton text={userId} />
            <a href={getDatabaseUserLink(userId)} target="_blank" rel="noopener noreferrer" className={linkClass} title="View in Firebase Console">
                <Flame size={16} className="text-gray-600" />
            </a>
            <a href={getRevenueCatCustomerLink(userId)} target="_blank" rel="noopener noreferrer" className={linkClass} title="View in RevenueCat">
                <Cat size={16} className="text-gray-600" />
            </a>
            <a href={getDbAdminLink(userId)} rel="noopener noreferrer" className={linkClass} title="View in Db Admin">
                <User size={16} className="text-gray-600" />
            </a>
        </>
    )

    if (mode === 'compact') {
        return (
            <div className="relative flex items-center gap-1" ref={menuRef} onClick={(e) => e.stopPropagation()}>
                <button
                    onClick={() => setMenuOpen((prev) => !prev)}
                    className={`${linkClass} flex items-center cursor-pointer`}
                    title="More actions"
                >
                    <MoreHorizontal size={16} className="text-gray-600" />
                </button>
                {menuOpen && (
                    <div className="absolute right-0 top-full mt-1 flex items-center gap-1 bg-white border border-gray-200 rounded shadow-md p-1 z-50">
                        {links}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
            {links}
        </div>
    )
}